import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES } from '../../i18n';
import type { Language } from '../../i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? 'ru') as Language;

  return (
    <label className="language-switcher">
      <span>{t('language.label')}</span>
      <select value={current} onChange={(e) => void i18n.changeLanguage(e.target.value)}>
        {SUPPORTED_LANGUAGES.map((code) => (
          <option key={code} value={code}>
            {t(`language.${code}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
